"use strict";
// Bullet split parser: derive child note definitions from a parent body.
// Pure logic so it can be unit tested independently.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.summarizeBulletParse = exports.parseBulletStructure = void 0;
var DEFAULT_HINT_MAP = {
    task: { topicGroup: 'Task' },
    todo: { topicGroup: 'Task' },
    info: { topicGroup: 'Info' },
    note: { topicGroup: 'Info' },
    bug: { topicGroup: 'Issue' },
    issue: { topicGroup: 'Issue' },
    idea: { topicGroup: 'Idea' },
    concept: { topicGroup: 'Idea' },
};
function parseBulletStructure(body, options) {
    if (options === void 0) { options = {}; }
    var forbidden = (options.forbiddenTopics || ['Session', 'Shift']).map(function (s) { return s.toLowerCase(); });
    var hintMap = __assign(__assign({}, DEFAULT_HINT_MAP), (options.hintMap || {}));
    var lines = (body || '')
        .replace(/\r\n?/g, '\n')
        .split('\n');
    var children = [];
    var skipped = 0;
    var current = null;
    var allowCont = options.allowContinuation !== false; // default true
    var maxChildren = options.maxChildren && options.maxChildren > 0 ? options.maxChildren : 500;
    var truncated = false;
    var inheritTG = function (tg) {
        if (!tg)
            return undefined;
        if (forbidden.includes(tg.toLowerCase()))
            return undefined;
        return tg;
    };
    for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
        var raw = lines_1[_i];
        var m = /^\s*-\s+(.+)$/.exec(raw);
        if (m) {
            // finish previous
            if (current) {
                if (current.body.trim() === '')
                    skipped++;
                else
                    children.push(current);
            }
            // check limit AFTER pushing previous, BEFORE processing new
            if (children.length >= maxChildren) {
                truncated = true;
                current = null; // clear current so we don't process this bullet
                break;
            }
            var rest = m[1];
            // detect inline hint token
            var hintToken = null;
            var remainder = rest;
            var hintMatch = /^(\w+)[\.:]\s+(.*)$/.exec(rest) || /^(\w+)[\.:]\s*$/.exec(rest);
            if (hintMatch) {
                hintToken = hintMatch[1];
                remainder = (hintMatch[2] || '').trim();
            }
            var draft = { body: remainder || (hintToken ? '' : rest).trim() };
            // apply inheritance
            draft.taskGroup = inheritTG(options.parentTaskGroup);
            draft.topicGroup = inheritTG(options.parentTopicGroup);
            draft.topicDetail = options.parentTopicDetail; // detail does not have forbidden restriction alone
            if (hintToken) {
                var key = hintToken.toLowerCase();
                var mapped = hintMap[key];
                if (mapped) {
                    if (mapped.taskGroup)
                        draft.taskGroup = mapped.taskGroup;
                    if (mapped.topicGroup)
                        draft.topicGroup = mapped.topicGroup;
                    if (mapped.topicDetail)
                        draft.topicDetail = mapped.topicDetail;
                }
                else {
                    // If hint token not mapped but matches a forbidden topic, ignore; else treat as first word of body
                    if (!remainder) {
                        draft.body = hintToken + (remainder ? (' ' + remainder) : '');
                    }
                }
            }
            current = draft;
        }
        else if (allowCont && current) {
            // continuation line
            if (/^\s*$/.test(raw)) {
                current.body += '\n';
            }
            else {
                current.body += (current.body.endsWith('\n') || current.body === '' ? '' : '\n') + raw.trimEnd();
            }
        }
    }
    if (current) {
        if (current.body.trim() === '')
            skipped++;
        else
            children.push(current);
    }
    return { children: children, skipped: skipped, truncated: truncated };
}
exports.parseBulletStructure = parseBulletStructure;
function summarizeBulletParse(res) {
    var parts = [];
    parts.push(res.children.length + ' child note' + (res.children.length === 1 ? '' : 's'));
    if (res.skipped)
        parts.push(res.skipped + ' skipped');
    if (res.truncated)
        parts.push('truncated');
    return parts.join(', ');
}
exports.summarizeBulletParse = summarizeBulletParse;
